import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useToast } from "~/hooks/use-toast";
import { supabase } from "~/integrations/supabase/client";

interface UpdateCheckDatesParams {
  checkId: number;
  receptionDate: string | null;
  collectionDate: string | null;
}

export function useUpdateCheckDates() {
  const queryClient = useQueryClient();
  const { toast } = useToast();

  return useMutation({
    mutationFn: async ({
      checkId,
      receptionDate,
      collectionDate,
    }: UpdateCheckDatesParams) => {
      const { error } = await supabase
        .from("payments")
        .update({
          reception_date: receptionDate,
          collection_date: collectionDate,
        })
        .eq("id", checkId);

      if (error) throw error;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["checks"] });
      toast({
        title: "Fechas actualizadas",
        description:
          "Las fechas del cheque han sido actualizadas correctamente",
      });
    },
    onError: (error: Error) => {
      toast({
        title: "Error",
        description: `No se pudieron actualizar las fechas: ${error.message}`,
        variant: "destructive",
      });
    },
  });
}
